module.exports = __webpack_public_path__ + "ab2adeedb8ad27c882c1a721fb3cb620.svg";